import React from 'react';
import { Chip } from '@mui/material';
import { FeedbackStatus } from '../../services/feedback.service';

export const FEEDBACK_STATUSES: { value: FeedbackStatus; label: string; color: 'info' | 'warning' | 'success' }[] = [
    { value: 'NEW', label: 'New', color: 'info' },
    { value: 'SEEN', label: 'Seen', color: 'warning' },
    { value: 'DONE', label: 'Done', color: 'success' },
];

export const FeedbackStatusChip: React.FC<{ status: FeedbackStatus }> = ({ status }) => {
    const s = FEEDBACK_STATUSES.find(x => x.value === status);
    return <Chip size="small" label={s?.label ?? status} color={s?.color ?? 'default'} />;
};
